import React from "react";
import "../styles/main.css";

import "react-lazy-load-image-component/src/effects/opacity.css";

import VFBr_mainPage from "../components/VFBr_mainPage";
import VFBr_Features from "../components/VFBr_Features";
import VFBr_Features2 from "../components/VFBr_Features2";
import VFBr_Features3 from "../components/VFBr_Features3";
import FAQ from "../components/FAQs";
import { faqsBrands } from "../components/FAQs_QandAOnly";
import  Contact  from "../components/Contact";
import Footer from "../components/Footer";

const VupopForBrands= () => {
  return (

    <>
    <VFBr_mainPage/>
    <VFBr_Features />
    <VFBr_Features2 />
    <VFBr_Features3 />
    <FAQ questions={faqsBrands} />
    <Footer/>
    </>
  );
};

export default VupopForBrands;